// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import { Application } from "@hotwired/stimulus"
import DynamicScreenFormController from "../controllers/dynamic_screen_form_controller"
import PortalCartaLogoPreviewController from "../controllers/portal_carta_logo_preview_controller"
import { createConsumer } from "@rails/actioncable"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

// Stimulus
const application = Application.start()
application.register("dynamic-screen-form", DynamicScreenFormController.default || DynamicScreenFormController)
application.register(
  "portal-carta-logo-preview",
  PortalCartaLogoPreviewController.default || PortalCartaLogoPreviewController
)

// Exponer ActionCable como global para vistas standalone (por ejemplo /tv con layout: false)
// Esto permite usar `ActionCable.createConsumer()` desde scripts inline.
window.ActionCable = window.ActionCable || {}
window.ActionCable.createConsumer = window.ActionCable.createConsumer || createConsumer
